module.exports = __webpack_public_path__ + "static/media/logo-jamshed.f55ab1df.jpg";